import {IoIosArrowForward} from 'react-icons/io';
import { FcHome } from "react-icons/fc";
import {Link, NavLink} from "react-router-dom";
import { categories } from "../utils/data";
import logo from "../assets/logo.png";

const isNotActiveStyle = 'flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize';
const isActiveStyle = 'flex items-center px-5 gap-3 font-extrabold border-r-2 border-black  transition-all duration-200 ease-in-out capitalize';

const Sidebar = ({ User,closeSideBarNow }) => {
    return (
        <div className="flex flex-col justify-between bg-white h-full overflow-y-scroll min-w-210 hide-scrollbar">
            <div className="flex flex-col">
                <Link to="/" className="flex px-5 gap-2 my-6 pt-1 w-190 items-center" onClick={closeSideBarNow}>
                    <img src={logo} alt="logo" className="w-full" />
                </Link>
                <div className="flex flex-col gap-2">
                    <NavLink to="/" className={({ isActive }) => ( isActive ? isActiveStyle : isNotActiveStyle)} onClick={closeSideBarNow}><FcHome /> Home</NavLink>
                    <h3 className="text-base mt-1 mb-1 px-5 2xl:text-xl">Discover cateogries</h3>
                    {
                        categories.map((obj,ind) => (
                            <NavLink to={`/category/${obj.name}`} className={({ isActive }) => ( isActive ? isActiveStyle : isNotActiveStyle)} key={ind} onClick={closeSideBarNow}>
                                <img src={obj.image} alt="..." className="w-8 h-8 rounded-full"/> {obj.name}
                            </NavLink>
                        ))
                    }
                </div>
            </div>
            <Link to={`/user-profile/${User.googleId}`} id="sidebar_f_data" className="flex gap-2 mt-2 mb-3 my-2 mx-2 justify-center items-center" onClick={closeSideBarNow}>
                <img src={User.imageUrl} alt="..." className="w-10 h-10 rounded-full"/>
                <p>{User.name}</p>
                <IoIosArrowForward />
            </Link>
        </div>
    )
};

export default Sidebar;